import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { FiArrowRight } from "react-icons/fi";

export default function Home() {
  const banners = [
    "/img/banner1.png",
    "/img/banner2.png",
    "/img/banner3.png"
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [banners.length]);

  return (
    <Container>
      {/* SECTION 1 - HERO CAROUSEL */}
      <CarouselSection>
        {banners.map((banner, index) => (
          <Slide
            key={index}
            isActive={index === current}
            style={{ backgroundImage: `url(${banner})` }}
          />
        ))}

        <Overlay>
          <BadgeText>V8 SOCIETY • THE MOTOR WORLD</BadgeText>
          <h1>Acelere sua <span>Paixão</span></h1>
          <p>Explore fichas técnicas, comparativos e o melhor conteúdo automotivo de 2026.</p>
          <div className="actions">
            <PrimaryButton>Explorar Catálogo</PrimaryButton>
            <SecondaryButton>Ver Notícias</SecondaryButton>
          </div>
        </Overlay>
        
        <CarouselDots>
          {banners.map((_, i) => (
            <Dot key={i} active={i === current} />
          ))}
        </CarouselDots>
      </CarouselSection>

      {/* SECTION 2 - DESTAQUES */}
      <Section>
        <div className="header-box">
          <h2>Ferramentas de <span>Destaque</span></h2>
          <p>Tudo o que você precisa para decidir seu próximo carro.</p>
        </div>
        
        <CardsGrid>
          <FeatureCard>
            <div className="icon">📄</div>
            <h3>Ficha Técnica</h3>
            <p>Dados precisos de performance e consumo.</p>
            <FiArrowRight className="arrow" />
          </FeatureCard>

          <FeatureCard>
            <div className="icon">⚖️</div>
            <h3>Comparativo</h3>
            <p>Coloque dois modelos lado a lado na pista.</p>
            <FiArrowRight className="arrow" />
          </FeatureCard>

          <FeatureCard>
            <div className="icon">💰</div>
            <h3>Tabela Fipe</h3>
            <p>Consulte valores de mercado atualizados.</p>
            <FiArrowRight className="arrow" />
          </FeatureCard>
        </CardsGrid>
      </Section>

      {/* SECTION 3 - SOBRE (CTA) */}
      <AboutSection>
        <AboutContent>
          <div className="text">
            <h2>Sobre a <span>V8 Society</span></h2>
            <p>
              Nascemos da vontade de entregar informação técnica de qualidade com uma 
              experiência visual moderna. Somos a maior comunidade de entusiastas 
              focada em dados reais e performance.
            </p>
          </div>
          <AboutStats>
            <div className="stat">
              <strong>+15k</strong>
              <span>Veículos</span>
            </div>
            <div className="stat">
              <strong>100%</strong>
              <span>Atualizado</span>
            </div>
          </AboutStats>
        </AboutContent>
      </AboutSection>
    </Container>
  );
}

/* ANIMAÇÕES */
const zoomEffect = keyframes`
  from { transform: scale(1); }
  to { transform: scale(1.1); }
`;

/* CONTAINER */
const Container = styled.div`
  width: 100%;
  background-color: #080808;
  color: white;
  font-family: 'Inter', sans-serif;
`;

/* CARROSSEL */
const CarouselSection = styled.section`
  width: 100%;
  height: 85vh;
  position: relative;
  overflow: hidden;
  background: #000;
`;

const Slide = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: opacity 1.5s ease-in-out;
  opacity: ${props => props.isActive ? 0.6 : 0};
  animation: ${props => props.isActive ? zoomEffect : 'none'} 10s linear infinite alternate;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, #080808 5%, transparent 60%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;
  z-index: 2;

  h1 {
    font-size: clamp(40px, 8vw, 90px);
    font-weight: 900;
    margin: 10px 0 20px;
    letter-spacing: -2px;
    span { color: #ff1a1a; }
  }

  p {
    font-size: clamp(16px, 2vw, 20px);
    max-width: 600px;
    color: #ccc;
    margin-bottom: 40px;
  }

  .actions {
    display: flex;
    gap: 20px;
  }
`;

const BadgeText = styled.span`
  color: #ff1a1a;
  font-weight: 800;
  letter-spacing: 4px;
  font-size: 12px;
  text-transform: uppercase;
`;

/* BOTÕES */
const PrimaryButton = styled.button`
  background: #ff1a1a;
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  &:hover { 
    background: #cc0000; 
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(255, 26, 26, 0.3);
  }
`;

const SecondaryButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 16px 32px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  &:hover { background: rgba(255, 255, 255, 0.2); }
`;

/* DESTAQUES */
const Section = styled.section`
  padding: 100px 40px;
  max-width: 1200px;
  margin: 0 auto;

  .header-box {
    margin-bottom: 60px;
    h2 { 
      font-size: 32px; 
      span { color: #ff1a1a; }
    }
    p { color: #888; }
  }
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const FeatureCard = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 40px;
  border-radius: 24px;
  transition: all 0.4s ease;
  position: relative;
  cursor: pointer;

  .icon { font-size: 40px; margin-bottom: 20px; }
  h3 { font-size: 22px; margin-bottom: 15px; }
  p { color: #888; line-height: 1.6; }
  .arrow { 
    position: absolute; 
    right: 30px; 
    bottom: 30px; 
    opacity: 0; 
    transition: 0.3s;
    color: #ff1a1a;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.07);
    transform: translateY(-10px);
    border-color: #ff1a1a;
    
    .arrow { opacity: 1; transform: translateX(5px); }
  }
`;

/* SOBRE */
const AboutSection = styled.section`
  background: #111;
  padding: 100px 40px;
`;

const AboutContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 60px;

  @media (max-width: 900px) { flex-direction: column; text-align: center; }

  .text {
    max-width: 600px;
    h2 { font-size: 36px; margin-bottom: 20px; span { color: #ff1a1a; } }
    p { color: #aaa; line-height: 1.8; }
  }
`;

const AboutStats = styled.div`
  display: flex;
  gap: 40px;
  .stat {
    strong { display: block; font-size: 40px; color: #ff1a1a; }
    span { color: #555; text-transform: uppercase; font-size: 12px; font-weight: 700; }
  }
`;

const CarouselDots = styled.div`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
`;

const Dot = styled.div`
  width: ${props => props.active ? '30px' : '8px'};
  height: 8px;
  background: ${props => props.active ? '#ff1a1a' : 'rgba(255,255,255,0.3)'};
  border-radius: 4px;
  transition: 0.3s;
`;